import * as React from 'react'
import { useShowContext, SimpleShowLayout, Show, useTranslate, Loading, Error } from 'react-admin'
import { Grid, Container } from '@mui/material'
import { CardCommon } from '../../../uiElements'
import { ShowListElement } from 'src/components/uiElements/CRUD/ShowListElement'
import { CardCrudBottomButtons } from 'src/components/uiElements/CRUD/CardCrudBottomButtons'
import { isUndefined } from 'src/helper/isUndefined'

const ShowWrapper = ({ children }) => <Container maxWidth='false'> {children}</Container>

const ShowContent = () => {
  const translate = useTranslate()
  const {
    error, // error returned by dataProvider when it failed to fetch the record. Useful if you want to adapt the view instead of just showing a notification using the `onError` side effect.
    isLoading, // boolean that is true until the record is available for the first time
    record, // record fetched via dataProvider.getOne() based on the id from the location
  } = useShowContext()

  if (isLoading) {
    return <Loading />
  }

  if (error) {
    return <Error />
  }
  
  return (
    <SimpleShowLayout>
      <CardCommon
        title={translate('ra.entity.commerce-number')}
        actions={<CardCrudBottomButtons btnEdit={true} />}
      >
        <Grid container spacing={3}>
          <ShowListElement label={translate('ra.field.id')} value={isUndefined(record.id)} />
          <ShowListElement
            label={translate('ra.field.client')}
            value={isUndefined(record?.client_relation?.long_name)}
          />
          <ShowListElement label={translate('ra.field.name')} value={isUndefined(record.name)} />
          <ShowListElement label={translate('ra.field.slug')} value={isUndefined(record.slug)} />
          <ShowListElement label={translate('ra.field.code')} value={isUndefined(record.code)} />
          <ShowListElement label={translate('ra.field.display')} value={isUndefined(record.display)} />
          <ShowListElement label={translate('ra.field.url')} value={isUndefined(record.url)} />
          <ShowListElement label={translate('ra.field.token')} value={isUndefined(record.token)} />
          <ShowListElement label={translate('ra.field.form')} value={isUndefined(record.form)} />
          <ShowListElement label={translate('ra.field.interest_display')} value={isUndefined(record.interest_display)} />
          <ShowListElement
            label={translate('ra.field.config')}
            value={isUndefined(record.config)}
            type={'json'}
          />
          <ShowListElement label={translate('ra.field.is_active')} value={record.is_active}  type={'boolean'} />
        </Grid>
      </CardCommon>
    </SimpleShowLayout>
  )
}

export const GatewayShow = (props) => {
  return (
    <Show component={ShowWrapper} {...props} className='CrudShowContainer' actions={null}>
      <ShowContent {...props} />
    </Show>
  )
}
